import { Stack } from '@fluentui/react';
import { H2OThemeProvider, ToastProvider } from '@h2oai/ui-kit';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { stackStylesAppContainer } from '../../themes/themes';
import { BannerProvider, CloudPlatformDiscoveryConfig, CloudPlatformDiscoveryProvider } from '../../utils/contexts';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { ProviderAppAuth } from '../ProviderAppAuth/ProviderAppAuth';
import { ProviderAppQueryClient } from '../ProviderAppQueryClient/ProviderAppQueryClient';

export interface AppProvidersProps {
  children: React.ReactNode;
  discovery: CloudPlatformDiscoveryConfig;
  auth: {
    authority: string;
    clientId: string;
  };
}

export const AppProviders = ({ children, discovery, auth }: AppProvidersProps) => (
  <CloudPlatformDiscoveryProvider discovery={discovery}>
    <ProviderAppAuth authority={auth.authority} client_id={auth.clientId}>
      <Stack styles={stackStylesAppContainer} data-test="app-main-container">
        <H2OThemeProvider>
          <ErrorBoundary>
            <ToastProvider>
              <ProviderAppQueryClient>
                <BrowserRouter>
                  <BannerProvider>{children}</BannerProvider>
                </BrowserRouter>
              </ProviderAppQueryClient>
            </ToastProvider>
          </ErrorBoundary>
        </H2OThemeProvider>
      </Stack>
    </ProviderAppAuth>
  </CloudPlatformDiscoveryProvider>
);
